import { render, staticRenderFns } from "./ChoicesTaskSetup.vue?vue&type=template&id=2ecfeae8&scoped=true"
import script from "./ChoicesTaskSetup.vue?vue&type=script&lang=ts"
export * from "./ChoicesTaskSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfeae8",
  null
  
)

export default component.exports